// extracted by mini-css-extract-plugin
export var container = "styles-module--container--56fa5";
export var content = "styles-module--content--c6108";
export var contrastOverlay = "styles-module--contrastOverlay--d415e";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var paddingLarge = "styles-module--paddingLarge--1cc06";
export var paddingRegular = "styles-module--paddingRegular--d9b13";
export var reducePaddingBottom = "styles-module--reducePaddingBottom--71781";
export var reducePaddingTop = "styles-module--reducePaddingTop--9ad3a";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";